// extracted by mini-css-extract-plugin
module.exports = {"toolbar":"UsersPage_toolbar__3bwuD","add":"UsersPage_add__1VVwT","table":"UsersPage_table__Q-HiK"};